module.exports = __webpack_public_path__ + "assets/administration.2412c5b7.svg";